type ResponsiveValue = number | string | Record<string, number | string>

const personaAvatarBaseSx = {
  background:
    'var(--app-avatar-bg, linear-gradient(180deg, rgba(255, 255, 255, 0.86) 0%, rgba(246, 250, 249, 0.7) 100%))',
  color: 'var(--app-avatar-color)',
  border: '1px solid var(--app-avatar-border)',
  boxShadow: 'var(--app-avatar-shadow)',
  backdropFilter: 'var(--app-avatar-blur)',
  WebkitBackdropFilter: 'var(--app-avatar-blur)',
  fontWeight: 600,
}

export const getPersonaAvatarSx = (
  size: ResponsiveValue,
  fontSize?: ResponsiveValue
) => ({
  ...personaAvatarBaseSx,
  width: size,
  height: size,
  fontSize: fontSize ?? 12,
})

export const getAvatarSx = (
  size: ResponsiveValue,
  hasImage?: boolean,
  fontSize?: ResponsiveValue
) =>
  hasImage
    ? {
        width: size,
        height: size,
      }
    : getPersonaAvatarSx(size, fontSize)
